// Auto-generated by extraction script
export const programCategories = [
  "Languages",
  "Arts & Social Sciences",
  "Science, Math & Tech",
  "Commerce & Management",
  "Music & Fine Arts",
  "Fine Arts",
  "Vocational",
  "Education",
];

export const programs = [
  {
    id: 1,
    name: "B.A. (Hons.) Arabic",
    category: "Languages",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 12,
          OBC_NCL: 8,
          SC: 4,
          ST: 2,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
    ],
  },
  {
    id: 2,
    name: "B.A. (Hons.) French",
    category: "Languages",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Department of Germanic and Romance Studies",
        seats: {
          UR: 19,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 3,
    name: "B.A. (Hons.) German",
    category: "Languages",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Department of Germanic and Romance Studies",
        seats: {
          UR: 19,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 4,
    name: "B.A. (Hons.) Italian",
    category: "Languages",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Department of Germanic and Romance Studies",
        seats: {
          UR: 19,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 5,
    name: "B.A. (Hons.) Spanish",
    category: "Languages",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Department of Germanic and Romance Studies",
        seats: {
          UR: 19,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 6,
    name: "B.A. (Hons.) Russian",
    category: "Languages",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Department of Slavonic & Finno-Ugrian Studies",
        seats: {
          UR: 19,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 7,
    name: "B.A. (Hons.) Bengali",
    category: "Languages",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
            specific: "Bengali",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
            specific: "Bengali",
          },
          {
            count: 1,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination III",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination IV",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Miranda House (W)",
        seats: {
          UR: 3,
          OBC_NCL: 3,
          SC: 2,
          ST: 1,
          EWS: 1,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 0,
          KM: 0,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 12,
          OBC_NCL: 8,
          SC: 4,
          ST: 2,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
    ],
  },
  {
    id: 8,
    name: "B.A. (Hons.) Punjabi",
    category: "Languages",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
            specific: "Punjabi",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
            specific: "Punjabi",
          },
          {
            count: 1,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination III",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination IV",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Dyal Singh College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Mata Sundri College for Women (W)",
        seats: {
          UR: 15,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 15,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Guru Gobind Singh College of Commerce",
        seats: {
          UR: 23,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 23,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Guru Nanak Dev Khalsa College",
        seats: {
          UR: 15,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 15,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 20,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 20,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 9,
    name: "B.A. (Hons.) Urdu",
    category: "Languages",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
            specific: "Urdu",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
            specific: "Urdu",
          },
          {
            count: 1,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination III",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination IV",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Dyal Singh College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 9,
          OBC_NCL: 6,
          SC: 4,
          ST: 2,
          EWS: 2,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Satyawati College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 0,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 19,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Zakir Husain Delhi College (Evening)",
        seats: {
          UR: 8,
          OBC_NCL: 5,
          SC: 3,
          ST: 1,
          EWS: 2,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
    ],
  },
  {
    id: 10,
    name: "B.A. (Hons.) English",
    category: "Languages",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
            specific: "English",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
            specific: "English",
          },
          {
            count: 1,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Aryabhatta College",
        seats: {
          UR: 42,
          OBC_NCL: 28,
          SC: 16,
          ST: 8,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Atma Ram Sanatan Dharma College",
        seats: {
          UR: 19,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Bharati College (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "College of Vocational Studies",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 5,
          KM: 4,
        },
      },
      {
        name: "Deen Dayal Upadhyaya College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Delhi College of Arts and Commerce",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Deshbandhu College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Dyal Singh College (Evening)",
        seats: {
          UR: 39,
          OBC_NCL: 26,
          SC: 14,
          ST: 7,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 1,
        },
      },
      {
        name: "Hansraj College",
        seats: {
          UR: 27,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Indraprastha College for Women (W)",
        seats: {
          UR: 26,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Janki Devi Memorial College (W)",
        seats: {
          UR: 27,
          OBC_NCL: 19,
          SC: 10,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Jesus & Mary College (W)",
        seats: {
          UR: 50,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 0,
          Christian: 50,
          PwBD: 5,
          CW: 5,
          KM: 4,
        },
      },
      {
        name: "Kalindi College (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 1,
        },
      },
      {
        name: "Kamala Nehru College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 0,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 22,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Lady Shri Ram College for Women (W)",
        seats: {
          UR: 43,
          OBC_NCL: 29,
          SC: 16,
          ST: 8,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Lakshmibai College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Maharaja Agrasen College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Maitreyi College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Mata Sundri College for Women (W)",
        seats: {
          UR: 30,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 30,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Motilal Nehru College",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Motilal Nehru College (Evening)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "P.G.D.A.V. College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Rajdhani College",
        seats: {
          UR: 24,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Ram Lal Anand College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Ramanujan College",
        seats: {
          UR: 25,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 0,
        },
      },
      {
        name: "Satyawati College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 4,
          KM: 0,
        },
      },
      {
        name: "Satyawati College (Evening)",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 0,
          KM: 0,
        },
      },
      {
        name: "Shaheed Bhagat Singh College",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shyam Lal College",
        seats: {
          UR: 47,
          OBC_NCL: 32,
          SC: 18,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Shyama Prasad Mukherji College For Women (W)",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Sri Aurobindo College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 1,
        },
      },
      {
        name: "Sri Aurobindo College (Evening)",
        seats: {
          UR: 24,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 3,
          KM: 0,
        },
      },
      {
        name: "Sri Guru Nanak Dev Khalsa College",
        seats: {
          UR: 15,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 15,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 20,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 20,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "St. Stephen's College",
        seats: {
          UR: 12,
          OBC_NCL: 0,
          SC: 2,
          ST: 1,
          EWS: 0,
          Sikh: 0,
          Christian: 15,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Swami Shardhanand College",
        seats: {
          UR: 35,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 4,
          KM: 1,
        },
      },
      {
        name: "Vivekananda College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Zakir Husain Delhi College (Evening)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
    ],
  },
  {
    id: 11,
    name: "B.A. (Hons.) Hindi",
    category: "Languages",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
            specific: "Hindi",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
            specific: "Hindi",
          },
          {
            count: 1,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Aryabhatta College",
        seats: {
          UR: 21,
          OBC_NCL: 14,
          SC: 8,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Atma Ram Sanatan Dharma College",
        seats: {
          UR: 19,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Bhagini Nivedita College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Bharati College (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "College of Vocational Studies",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 47,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 7,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Deshbandhu College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Dr. Bhim Rao Ambedkar College",
        seats: {
          UR: 24,
          OBC_NCL: 15,
          SC: 9,
          ST: 5,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 1,
        },
      },
      {
        name: "Hansraj College",
        seats: {
          UR: 27,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Indraprastha College for Women (W)",
        seats: {
          UR: 26,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Janki Devi Memorial College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Jesus & Mary College (W)",
        seats: {
          UR: 25,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 0,
          Christian: 25,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Kalindi College (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 1,
        },
      },
      {
        name: "Kamala Nehru College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 0,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 22,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Lady Shri Ram College for Women (W)",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Lakshmibai College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Maharaja Agrasen College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Maitreyi College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Mata Sundri College for Women (W)",
        seats: {
          UR: 58,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 58,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Motilal Nehru College",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Motilal Nehru College (Evening)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "P.G.D.A.V. College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "P.G.D.A.V. College (Evening)",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Rajdhani College",
        seats: {
          UR: 24,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Ram Lal Anand College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Ramanujan College",
        seats: {
          UR: 25,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 0,
        },
      },
      {
        name: "Satyawati College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 0,
        },
      },
      {
        name: "Satyawati College (Evening)",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 0,
          KM: 0,
        },
      },
      {
        name: "Shaheed Bhagat Singh College",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shyam Lal College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shyam Lal College (Evening)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shyama Prasad Mukherji College For Women (W)",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Sri Aurobindo College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 1,
        },
      },
      {
        name: "Sri Aurobindo College (Evening)",
        seats: {
          UR: 24,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 3,
          KM: 0,
        },
      },
      {
        name: "Sri Guru Nanak Dev Khalsa College",
        seats: {
          UR: 15,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 15,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 20,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 20,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Swami Shardhanand College",
        seats: {
          UR: 35,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 4,
          KM: 1,
        },
      },
      {
        name: "Vivekananda College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 19,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Zakir Husain Delhi College (Evening)",
        seats: {
          UR: 8,
          OBC_NCL: 5,
          SC: 3,
          ST: 1,
          EWS: 2,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
    ],
  },
  {
    id: 12,
    name: "B.A. (Hons.) Persian",
    category: "Languages",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 12,
          OBC_NCL: 8,
          SC: 4,
          ST: 2,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Zakir Husain Delhi College (Evening)",
        seats: {
          UR: 8,
          OBC_NCL: 5,
          SC: 3,
          ST: 1,
          EWS: 2,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
    ],
  },
  {
    id: 13,
    name: "B.A. (Hons.) Sanskrit",
    category: "Languages",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Language",
            specific: "Sanskrit",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
            specific: "Sanskrit",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination III",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination IV",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Bharati College (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 19,
          OBC_NCL: 12,
          SC: 7,
          ST: 3,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Deshbandhu College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 19,
          OBC_NCL: 13,
          SC: 7,
          ST: 3,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Hansraj College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 12,
          OBC_NCL: 8,
          SC: 4,
          ST: 2,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Indraprastha College for Women (W)",
        seats: {
          UR: 26,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Janki Devi Memorial College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Kalindi College (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 1,
        },
      },
      {
        name: "Kamala Nehru College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 9,
          OBC_NCL: 6,
          SC: 4,
          ST: 2,
          EWS: 2,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Lady Shri Ram College for Women (W)",
        seats: {
          UR: 12,
          OBC_NCL: 8,
          SC: 4,
          ST: 2,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Lakshmibai College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Maitreyi College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Mata Sundri College for Women (W)",
        seats: {
          UR: 12,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 12,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 15,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Motilal Nehru College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "P.G.D.A.V. College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "P.G.D.A.V. College (Evening)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Rajdhani College",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 12,
          OBC_NCL: 8,
          SC: 5,
          ST: 2,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Satyawati College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 0,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shyama Prasad Mukherji College for Women (W)",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "St. Stephen's College",
        seats: {
          UR: 3,
          OBC_NCL: 0,
          SC: 1,
          ST: 1,
          EWS: 0,
          Sikh: 0,
          Christian: 5,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Vivekananda College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 12,
          OBC_NCL: 8,
          SC: 4,
          ST: 2,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Zakir Husain Delhi College (Evening)",
        seats: {
          UR: 8,
          OBC_NCL: 5,
          SC: 3,
          ST: 1,
          EWS: 2,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
    ],
  },
  {
    id: 14,
    name: "B.A. (Hons.) Applied Psychology",
    category: "Arts & Social Sciences",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Dr. Bhim Rao Ambedkar College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 19,
          OBC_NCL: 13,
          SC: 7,
          ST: 3,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Ramanujan College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 2,
          KM: 3,
        },
      },
      {
        name: "Shyama Prasad Mukherji College For Women (W)",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Sri Aurobindo College (Evening)",
        seats: {
          UR: 24,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 3,
          KM: 0,
        },
      },
      {
        name: "Vivekananda College (W)",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 15,
    name: "B.A. (Hons.) Psychology",
    category: "Arts & Social Sciences",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Aryabhatta College",
        seats: {
          UR: 21,
          OBC_NCL: 14,
          SC: 8,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Bharati College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 19,
          OBC_NCL: 12,
          SC: 7,
          ST: 3,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Indraprastha College for Women (W)",
        seats: {
          UR: 26,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Jesus & Mary College (W)",
        seats: {
          UR: 25,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 0,
          Christian: 25,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Kamala Nehru College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 0,
        },
      },
      {
        name: "Keshav Mahavidyalaya",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Lady Shri Ram College for Women (W)",
        seats: {
          UR: 25,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Lakshmibai College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Mata Sundri College for Women (W)",
        seats: {
          UR: 52,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 53,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
    ],
  },
  {
    id: 16,
    name: "B.A. (Hons.) Philosophy",
    category: "Arts & Social Sciences",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 19,
          OBC_NCL: 13,
          SC: 8,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Hansraj College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Indraprastha College for Women (W)",
        seats: {
          UR: 26,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Janki Devi Memorial College (W)",
        seats: {
          UR: 15,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Kamala Nehru College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 1,
        },
      },
      {
        name: "Lady Shri Ram College for Women (W)",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Lakshmibai College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Mata Sundri College for Women (W)",
        seats: {
          UR: 22,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 22,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Ramanujan College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 2,
          KM: 3,
        },
      },
      {
        name: "Shyama Prasad Mukherji College for Women (W)",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "St. Stephen's College",
        seats: {
          UR: 3,
          OBC_NCL: 0,
          SC: 1,
          ST: 1,
          EWS: 0,
          Sikh: 0,
          Christian: 5,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 17,
    name: "B.A. (Hons.) Political Science",
    category: "Arts & Social Sciences",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Aryabhatta College",
        seats: {
          UR: 42,
          OBC_NCL: 28,
          SC: 16,
          ST: 8,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Atma Ram Sanatan Dharma College",
        seats: {
          UR: 38,
          OBC_NCL: 26,
          SC: 14,
          ST: 7,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Bhagini Nivedita College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Bharati College (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 47,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 7,
        },
      },
      {
        name: "Delhi College of Arts and Commerce",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Deshbandhu College",
        seats: {
          UR: 62,
          OBC_NCL: 42,
          SC: 23,
          ST: 12,
          EWS: 15,
          Sikh: 0,
          Christian: 0,
          PwBD: 8,
          CW: 8,
          KM: 8,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Dyal Singh College (Evening)",
        seats: {
          UR: 39,
          OBC_NCL: 26,
          SC: 14,
          ST: 7,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 46,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 2,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Indraprastha College for Women (W)",
        seats: {
          UR: 57,
          OBC_NCL: 38,
          SC: 21,
          ST: 11,
          EWS: 15,
          Sikh: 0,
          Christian: 0,
          PwBD: 7,
          CW: 8,
          KM: 8,
        },
      },
      {
        name: "Janki Devi Memorial College (W)",
        seats: {
          UR: 47,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Jesus & Mary College (W)",
        seats: {
          UR: 25,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 0,
          Christian: 25,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Kalindi College (W)",
        seats: {
          UR: 62,
          OBC_NCL: 42,
          SC: 23,
          ST: 12,
          EWS: 15,
          Sikh: 0,
          Christian: 0,
          PwBD: 8,
          CW: 8,
          KM: 2,
        },
      },
      {
        name: "Kamala Nehru College (W)",
        seats: {
          UR: 47,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 1,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 26,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Lady Shri Ram College for Women (W)",
        seats: {
          UR: 43,
          OBC_NCL: 29,
          SC: 16,
          ST: 8,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Lakshmibai College (W)",
        seats: {
          UR: 46,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Maharaja Agrasen College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Maitreyi College (W)",
        seats: {
          UR: 47,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Mata Sundri College for Women (W)",
        seats: {
          UR: 60,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 60,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 28,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Motilal Nehru College",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Motilal Nehru College (Evening)",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "P.G.D.A.V. College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "P.G.D.A.V. College (Evening)",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Rajdhani College",
        seats: {
          UR: 24,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Ram Lal Anand College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Ramanujan College",
        seats: {
          UR: 25,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 0,
        },
      },
      {
        name: "Satyawati College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 0,
        },
      },
      {
        name: "Satyawati College (Evening)",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 0,
          KM: 0,
        },
      },
      {
        name: "Shaheed Bhagat Singh College",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shaheed Bhagat Singh College (Evening)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shyam Lal College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shyam Lal College (Evening)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shyama Prasad Mukherji College For Women (W)",
        seats: {
          UR: 47,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Sri Aurobindo College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 5,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 2,
        },
      },
      {
        name: "Sri Guru Nanak Dev Khalsa College",
        seats: {
          UR: 15,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 15,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 20,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 20,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Vivekananda College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 54,
          OBC_NCL: 37,
          SC: 21,
          ST: 11,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 7,
          CW: 7,
          KM: 6,
        },
      },
      {
        name: "Zakir Husain Delhi College (Evening)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
    ],
  },
  {
    id: 18,
    name: "B.A. (Hons.) Social Work",
    category: "Arts & Social Sciences",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Aditi Mahavidyalaya (W)",
        seats: {
          UR: 22,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Dr. Bhim Rao Ambedkar College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 11,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
    ],
  },
  {
    id: 19,
    name: "B.A. (Hons.) Sociology",
    category: "Arts & Social Sciences",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Bharati College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Indraprastha College for Women (W)",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Janki Devi Memorial College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Jesus & Mary College (W)",
        seats: {
          UR: 25,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 0,
          Christian: 25,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Kamala Nehru College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 1,
        },
      },
      {
        name: "Lady Shri Ram College for Women (W)",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Lakshmibai College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Maitreyi College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 26,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 20,
    name: "B.A. (Hons.) Economics",
    category: "Arts & Social Sciences",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Aryabhatta College",
        seats: {
          UR: 21,
          OBC_NCL: 14,
          SC: 8,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Atma Ram Sanatan Dharma College",
        seats: {
          UR: 38,
          OBC_NCL: 26,
          SC: 14,
          ST: 7,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "College of Vocational Studies",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 47,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Delhi College of Arts and Commerce",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Deshbandhu College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Dr. Bhim Rao Ambedkar College",
        seats: {
          UR: 24,
          OBC_NCL: 15,
          SC: 9,
          ST: 5,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 1,
        },
      },
      {
        name: "Hansraj College",
        seats: {
          UR: 55,
          OBC_NCL: 36,
          SC: 20,
          ST: 10,
          EWS: 14,
          Sikh: 0,
          Christian: 0,
          PwBD: 7,
          CW: 7,
          KM: 7,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 28,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Indraprastha College for Women (W)",
        seats: {
          UR: 26,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Janki Devi Memorial College (W)",
        seats: {
          UR: 27,
          OBC_NCL: 19,
          SC: 10,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Jesus & Mary College (W)",
        seats: {
          UR: 25,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 0,
          Christian: 25,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Kalindi College (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 1,
        },
      },
      {
        name: "Kamala Nehru College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 1,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Lady Shri Ram College for Women (W)",
        seats: {
          UR: 43,
          OBC_NCL: 29,
          SC: 16,
          ST: 8,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Lakshmibai College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Maitreyi College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Motilal Nehru College",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "P.G.D.A.V. College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Rajdhani College",
        seats: {
          UR: 24,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Ramanujan College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 2,
          KM: 3,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Satyawati College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 0,
        },
      },
      {
        name: "Satyawati College (Evening)",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 0,
          KM: 0,
        },
      },
      {
        name: "Shaheed Bhagat Singh College",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shri Ram College of Commerce",
        seats: {
          UR: 63,
          OBC_NCL: 42,
          SC: 23,
          ST: 12,
          EWS: 15,
          Sikh: 0,
          Christian: 0,
          PwBD: 8,
          CW: 8,
          KM: 8,
        },
      },
      {
        name: "Shyam Lal College",
        seats: {
          UR: 47,
          OBC_NCL: 32,
          SC: 18,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Shyam Lal College (Evening)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shyama Prasad Mukherji College For Women (W)",
        seats: {
          UR: 47,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Sri Aurobindo College (Evening)",
        seats: {
          UR: 24,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 3,
          KM: 0,
        },
      },
      {
        name: "Sri Guru Gobind Singh College of Commerce",
        seats: {
          UR: 40,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 40,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 20,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 20,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "St. Stephen's College",
        seats: {
          UR: 21,
          OBC_NCL: 0,
          SC: 3,
          ST: 1,
          EWS: 0,
          Sikh: 0,
          Christian: 25,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 19,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 21,
    name: "B.A. (Hons.) Geography",
    category: "Arts & Social Sciences",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Alternative Combination",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Aditi Mahavidyalaya (W)",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Dr. Bhim Rao Ambedkar College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Indraprastha College for Women (W)",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Kalindi College (W)",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 1,
        },
      },
      {
        name: "Kamala Nehru College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 1,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 22,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shaheed Bhagat Singh College",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shaheed Bhagat Singh College (Evening)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shyama Prasad Mukherji College for Women (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Swami Shardhanand College",
        seats: {
          UR: 35,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 4,
          KM: 1,
        },
      },
    ],
  },
  {
    id: 22,
    name: "B.A. (Hons.) Hindi Patrakarita",
    category: "Arts & Social Sciences",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
            specific: "Hindi",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
            specific: "Hindi",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Aditi Mahavidyalaya (W)",
        seats: {
          UR: 22,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Dr. Bhim Rao Ambedkar College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 11,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Ram Lal Anand College",
        seats: {
          UR: 10,
          OBC_NCL: 7,
          SC: 4,
          ST: 2,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Sri Guru Nanak Dev Khalsa College",
        seats: {
          UR: 20,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 20,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 23,
    name: "B.A. (Hons.) History",
    category: "Arts & Social Sciences",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Aryabhatta College",
        seats: {
          UR: 42,
          OBC_NCL: 28,
          SC: 16,
          ST: 8,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Atma Ram Sanatan Dharma College",
        seats: {
          UR: 19,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Bhagini Nivedita College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Bharati College (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "College of Vocational Studies",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Delhi College of Arts and Commerce",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Deshbandhu College",
        seats: {
          UR: 47,
          OBC_NCL: 32,
          SC: 18,
          ST: 9,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Dr. Bhim Rao Ambedkar College",
        seats: {
          UR: 24,
          OBC_NCL: 15,
          SC: 9,
          ST: 5,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Dyal Singh College (Evening)",
        seats: {
          UR: 21,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 1,
        },
      },
      {
        name: "Hansraj College",
        seats: {
          UR: 27,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Indraprastha College for Women (W)",
        seats: {
          UR: 26,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Janki Devi Memorial College (W)",
        seats: {
          UR: 39,
          OBC_NCL: 26,
          SC: 14,
          ST: 7,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Jesus & Mary College (W)",
        seats: {
          UR: 25,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 0,
          Christian: 25,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Kalindi College (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 1,
        },
      },
      {
        name: "Kamala Nehru College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 1,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 22,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Lady Shri Ram College for Women (W)",
        seats: {
          UR: 43,
          OBC_NCL: 29,
          SC: 16,
          ST: 8,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Lakshmibai College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Maitreyi College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Mata Sundri College for Women (W)",
        seats: {
          UR: 30,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 30,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Motilal Nehru College",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Motilal Nehru College (Evening)",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "P.G.D.A.V. College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Rajdhani College",
        seats: {
          UR: 24,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Ram Lal Anand College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Satyawati College",
        seats: {
          UR: 43,
          OBC_NCL: 29,
          SC: 16,
          ST: 8,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 0,
        },
      },
      {
        name: "Satyawati College (Evening)",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 0,
          KM: 0,
        },
      },
      {
        name: "Shaheed Bhagat Singh College",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shyam Lal College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shyama Prasad Mukherji College For Women (W)",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Sri Guru Nanak Dev Khalsa College",
        seats: {
          UR: 15,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 15,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 20,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 20,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "St. Stephen's College",
        seats: {
          UR: 24,
          OBC_NCL: 0,
          SC: 4,
          ST: 2,
          EWS: 0,
          Sikh: 0,
          Christian: 30,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Swami Shardhanand College",
        seats: {
          UR: 35,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 4,
          KM: 1,
        },
      },
      {
        name: "Vivekananda College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 19,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Zakir Husain Delhi College (Evening)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
    ],
  },
  {
    id: 24,
    name: "B.A. (Hons.) Humanities & Social Sciences",
    category: "Arts & Social Sciences",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Cluster Innovation Centre",
        seats: {
          UR: 20,
          OBC_NCL: 14,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 0,
        },
      },
    ],
  },
  {
    id: 25,
    name: "B.A. (Hons.) Journalism",
    category: "Arts & Social Sciences",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
            specific: "English",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
            specific: "English",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Bharati College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Delhi College of Arts and Commerce",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Institute of Home Economics (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Kalindi College (W)",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 1,
        },
      },
      {
        name: "Kamala Nehru College (W)",
        seats: {
          UR: 19,
          OBC_NCL: 14,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 0,
        },
      },
      {
        name: "Lady Shri Ram College for Women (W)",
        seats: {
          UR: 12,
          OBC_NCL: 8,
          SC: 4,
          ST: 2,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Maharaja Agrasen College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
    ],
  },
  {
    id: 26,
    name: "Five Year Integrated Program in Journalism",
    category: "Arts & Social Sciences",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mass Media / Mass Communication",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Delhi School of Journalism",
        seats: {
          UR: 40,
          OBC_NCL: 27,
          SC: 15,
          ST: 8,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 0,
        },
      },
    ],
  },
  {
    id: 27,
    name: "B.A. (Hons.) Multimedia and Mass Communication",
    category: "Arts & Social Sciences",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Indraprastha College for Women (W)",
        seats: {
          UR: 26,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 3,
          KM: 3,
        },
      },
    ],
  },
  {
    id: 28,
    name: "B.A. (Program)",
    category: "Arts & Social Sciences",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination III",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Aditi Mahavidyalaya (W)",
        seats: {
          UR: 272,
          OBC_NCL: 181,
          SC: 101,
          ST: 50,
          EWS: 68,
          Sikh: 0,
          Christian: 0,
          CW: 34,
          PwBD: 34,
          KM: 34,
        },
      },
      {
        name: "Aryabhatta College",
        seats: {
          UR: 63,
          OBC_NCL: 42,
          SC: 24,
          ST: 12,
          EWS: 15,
          Sikh: 0,
          Christian: 0,
          CW: 9,
          PwBD: 9,
          KM: 9,
        },
      },
      {
        name: "Atma Ram Sanatan Dharma College",
        seats: {
          UR: 45,
          OBC_NCL: 32,
          SC: 18,
          ST: 9,
          EWS: 14,
          Sikh: 0,
          Christian: 0,
          CW: 6,
          PwBD: 6,
          KM: 6,
        },
      },
      {
        name: "Bhagini Nivedita College (W)",
        seats: {
          UR: 203,
          OBC_NCL: 136,
          SC: 79,
          ST: 41,
          EWS: 51,
          Sikh: 0,
          Christian: 0,
          CW: 26,
          PwBD: 26,
          KM: 17,
        },
      },
      {
        name: "Bharati College (W)",
        seats: {
          UR: 93,
          OBC_NCL: 62,
          SC: 36,
          ST: 17,
          EWS: 23,
          Sikh: 0,
          Christian: 0,
          CW: 12,
          PwBD: 12,
          KM: 12,
        },
      },
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 85,
          OBC_NCL: 57,
          SC: 32,
          ST: 16,
          EWS: 21,
          Sikh: 0,
          Christian: 0,
          CW: 10,
          PwBD: 10,
          KM: 10,
        },
      },
      {
        name: "Deen Dayal Upadhyaya College",
        seats: {
          UR: 48,
          OBC_NCL: 33,
          SC: 18,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          CW: 6,
          PwBD: 6,
          KM: 6,
        },
      },
      {
        name: "Delhi College of Arts and Commerce",
        seats: {
          UR: 69,
          OBC_NCL: 46,
          SC: 26,
          ST: 13,
          EWS: 17,
          Sikh: 0,
          Christian: 0,
          CW: 8,
          PwBD: 8,
          KM: 8,
        },
      },
      {
        name: "Deshbandhu College",
        seats: {
          UR: 96,
          OBC_NCL: 64,
          SC: 35,
          ST: 18,
          EWS: 24,
          Sikh: 0,
          Christian: 0,
          CW: 12,
          PwBD: 12,
          KM: 12,
        },
      },
      {
        name: "Dr. Bhim Rao Ambedkar College",
        seats: {
          UR: 164,
          OBC_NCL: 109,
          SC: 61,
          ST: 32,
          EWS: 39,
          Sikh: 0,
          Christian: 0,
          CW: 18,
          PwBD: 19,
          KM: 19,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 93,
          OBC_NCL: 62,
          SC: 36,
          ST: 17,
          EWS: 23,
          Sikh: 0,
          Christian: 0,
          CW: 11,
          PwBD: 12,
          KM: 12,
        },
      },
      {
        name: "Dyal Singh College (Evening)",
        seats: {
          UR: 170,
          OBC_NCL: 115,
          SC: 65,
          ST: 31,
          EWS: 43,
          Sikh: 0,
          Christian: 0,
          CW: 21,
          PwBD: 21,
          KM: 21,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 93,
          OBC_NCL: 62,
          SC: 35,
          ST: 17,
          EWS: 23,
          Sikh: 0,
          Christian: 0,
          CW: 10,
          PwBD: 11,
          KM: 4,
        },
      },
      {
        name: "Hansraj College",
        seats: {
          UR: 100,
          OBC_NCL: 70,
          SC: 40,
          ST: 20,
          EWS: 20,
          Sikh: 0,
          Christian: 0,
          CW: 15,
          PwBD: 15,
          KM: 15,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 20,
          OBC_NCL: 14,
          SC: 8,
          ST: 4,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          CW: 4,
          PwBD: 4,
          KM: 4,
        },
      },
      {
        name: "Indraprastha College for Women (W)",
        seats: {
          UR: 115,
          OBC_NCL: 77,
          SC: 45,
          ST: 24,
          EWS: 24,
          Sikh: 0,
          Christian: 0,
          CW: 14,
          PwBD: 22,
          KM: 14,
        },
      },
      {
        name: "Janki Devi Memorial College (W)",
        seats: {
          UR: 116,
          OBC_NCL: 71,
          SC: 41,
          ST: 29,
          EWS: 32,
          Sikh: 0,
          Christian: 0,
          CW: 13,
          PwBD: 13,
          KM: 13,
        },
      },
      {
        name: "Jesus & Mary College (W)",
        seats: {
          UR: 273,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 0,
          Christian: 273,
          CW: 21,
          PwBD: 21,
          KM: 21,
        },
      },
      {
        name: "Kalindi College (W)",
        seats: {
          UR: 119,
          OBC_NCL: 77,
          SC: 41,
          ST: 22,
          EWS: 30,
          Sikh: 0,
          Christian: 0,
          CW: 0,
          PwBD: 7,
          KM: 0,
        },
      },
      {
        name: "Kamala Nehru College (W)",
        seats: {
          UR: 62,
          OBC_NCL: 42,
          SC: 23,
          ST: 12,
          EWS: 16,
          Sikh: 0,
          Christian: 0,
          CW: 8,
          PwBD: 8,
          KM: 12,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 43,
          OBC_NCL: 26,
          SC: 17,
          ST: 10,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          CW: 5,
          PwBD: 5,
          KM: 5,
        },
      },
      {
        name: "Lady Shri Ram College for Women (W)",
        seats: {
          UR: 34,
          OBC_NCL: 19,
          SC: 10,
          ST: 9,
          EWS: 9,
          Sikh: 0,
          Christian: 0,
          CW: 4,
          PwBD: 4,
          KM: 1,
        },
      },
      {
        name: "Lakshmibai College (W)",
        seats: {
          UR: 214,
          OBC_NCL: 144,
          SC: 80,
          ST: 40,
          EWS: 53,
          Sikh: 0,
          Christian: 0,
          CW: 27,
          PwBD: 27,
          KM: 27,
        },
      },
      {
        name: "Maharaja Agrasen College",
        seats: {
          UR: 77,
          OBC_NCL: 52,
          SC: 29,
          ST: 15,
          EWS: 20,
          Sikh: 0,
          Christian: 0,
          CW: 10,
          PwBD: 10,
          KM: 10,
        },
      },
      {
        name: "Maitreyi College (W)",
        seats: {
          UR: 95,
          OBC_NCL: 62,
          SC: 34,
          ST: 17,
          EWS: 23,
          Sikh: 0,
          Christian: 0,
          CW: 11,
          PwBD: 11,
          KM: 11,
        },
      },
      {
        name: "Mata Sundri College for Women (W)",
        seats: {
          UR: 126,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 126,
          Christian: 0,
          CW: 18,
          PwBD: 18,
          KM: 18,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 93,
          OBC_NCL: 65,
          SC: 35,
          ST: 12,
          EWS: 26,
          Sikh: 0,
          Christian: 0,
          CW: 8,
          PwBD: 8,
          KM: 8,
        },
      },
      {
        name: "Motilal Nehru College",
        seats: {
          UR: 140,
          OBC_NCL: 93,
          SC: 52,
          ST: 26,
          EWS: 35,
          Sikh: 0,
          Christian: 0,
          CW: 17,
          PwBD: 16,
          KM: 9,
        },
      },
      {
        name: "Motilal Nehru College (Evening)",
        seats: {
          UR: 186,
          OBC_NCL: 124,
          SC: 69,
          ST: 35,
          EWS: 46,
          Sikh: 0,
          Christian: 0,
          CW: 23,
          PwBD: 23,
          KM: 23,
        },
      },
      {
        name: "P.G.D.A.V. College",
        seats: {
          UR: 94,
          OBC_NCL: 62,
          SC: 35,
          ST: 17,
          EWS: 23,
          Sikh: 0,
          Christian: 0,
          CW: 12,
          PwBD: 13,
          KM: 12,
        },
      },
      {
        name: "P.G.D.A.V. College (Evening)",
        seats: {
          UR: 140,
          OBC_NCL: 93,
          SC: 50,
          ST: 27,
          EWS: 37,
          Sikh: 0,
          Christian: 0,
          CW: 17,
          PwBD: 17,
          KM: 17,
        },
      },
      {
        name: "Rajdhani College",
        seats: {
          UR: 95,
          OBC_NCL: 62,
          SC: 34,
          ST: 17,
          EWS: 23,
          Sikh: 0,
          Christian: 0,
          CW: 11,
          PwBD: 11,
          KM: 11,
        },
      },
      {
        name: "Ram Lal Anand College",
        seats: {
          UR: 39,
          OBC_NCL: 26,
          SC: 15,
          ST: 7,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          CW: 5,
          PwBD: 5,
          KM: 5,
        },
      },
      {
        name: "Ramanujan College",
        seats: {
          UR: 50,
          OBC_NCL: 33,
          SC: 20,
          ST: 9,
          EWS: 14,
          Sikh: 0,
          Christian: 0,
          CW: 11,
          PwBD: 11,
          KM: 10,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 56,
          OBC_NCL: 38,
          SC: 21,
          ST: 10,
          EWS: 14,
          Sikh: 0,
          Christian: 0,
          CW: 7,
          PwBD: 7,
          KM: 7,
        },
      },
      {
        name: "Satyawati College",
        seats: {
          UR: 169,
          OBC_NCL: 93,
          SC: 46,
          ST: 29,
          EWS: 32,
          Sikh: 0,
          Christian: 0,
          CW: 19,
          PwBD: 16,
          KM: 0,
        },
      },
      {
        name: "Satyawati College (Evening)",
        seats: {
          UR: 145,
          OBC_NCL: 95,
          SC: 52,
          ST: 27,
          EWS: 35,
          Sikh: 0,
          Christian: 0,
          CW: 0,
          PwBD: 0,
          KM: 0,
        },
      },
      {
        name: "Shaheed Bhagat Singh College",
        seats: {
          UR: 42,
          OBC_NCL: 30,
          SC: 18,
          ST: 12,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          CW: 6,
          PwBD: 6,
          KM: 6,
        },
      },
      {
        name: "Shaheed Bhagat Singh College (Evening)",
        seats: {
          UR: 95,
          OBC_NCL: 62,
          SC: 34,
          ST: 16,
          EWS: 23,
          Sikh: 0,
          Christian: 0,
          CW: 11,
          PwBD: 10,
          KM: 10,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 93,
          OBC_NCL: 63,
          SC: 35,
          ST: 17,
          EWS: 23,
          Sikh: 0,
          Christian: 0,
          CW: 12,
          PwBD: 12,
          KM: 12,
        },
      },
      {
        name: "Shyam Lal College",
        seats: {
          UR: 78,
          OBC_NCL: 52,
          SC: 30,
          ST: 14,
          EWS: 19,
          Sikh: 0,
          Christian: 0,
          CW: 9,
          PwBD: 9,
          KM: 9,
        },
      },
      {
        name: "Shyam Lal College (Evening)",
        seats: {
          UR: 94,
          OBC_NCL: 65,
          SC: 38,
          ST: 16,
          EWS: 25,
          Sikh: 0,
          Christian: 0,
          CW: 12,
          PwBD: 12,
          KM: 12,
        },
      },
      {
        name: "Shyama Prasad Mukherji College For Women (W)",
        seats: {
          UR: 193,
          OBC_NCL: 129,
          SC: 70,
          ST: 41,
          EWS: 47,
          Sikh: 0,
          Christian: 0,
          CW: 20,
          PwBD: 20,
          KM: 20,
        },
      },
      {
        name: "Sri Aurobindo College (Day)",
        seats: {
          UR: 153,
          OBC_NCL: 105,
          SC: 59,
          ST: 29,
          EWS: 39,
          Sikh: 0,
          Christian: 0,
          CW: 19,
          PwBD: 19,
          KM: 10,
        },
      },
      {
        name: "Sri Aurobindo College (Evening)",
        seats: {
          UR: 117,
          OBC_NCL: 78,
          SC: 43,
          ST: 22,
          EWS: 29,
          Sikh: 0,
          Christian: 0,
          CW: 15,
          PwBD: 0,
          KM: 0,
        },
      },
      {
        name: "Sri Guru Nanak Dev Khalsa College",
        seats: {
          UR: 60,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 60,
          Christian: 0,
          CW: 9,
          PwBD: 6,
          KM: 9,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 30,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 30,
          Christian: 0,
          CW: 3,
          PwBD: 3,
          KM: 3,
        },
      },
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 47,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          CW: 7,
          PwBD: 7,
          KM: 7,
        },
      },
      {
        name: "St. Stephen's College",
        seats: {
          UR: 21,
          OBC_NCL: 0,
          SC: 3,
          ST: 1,
          EWS: 0,
          Sikh: 0,
          Christian: 25,
          CW: 3,
          PwBD: 3,
          KM: 3,
        },
      },
      {
        name: "Swami Shardhanand College",
        seats: {
          UR: 157,
          OBC_NCL: 91,
          SC: 51,
          ST: 27,
          EWS: 20,
          Sikh: 0,
          Christian: 0,
          CW: 17,
          PwBD: 11,
          KM: 6,
        },
      },
      {
        name: "Vivekananda College (W)",
        seats: {
          UR: 78,
          OBC_NCL: 53,
          SC: 30,
          ST: 16,
          EWS: 15,
          Sikh: 0,
          Christian: 0,
          CW: 10,
          PwBD: 15,
          KM: 15,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 156,
          OBC_NCL: 104,
          SC: 58,
          ST: 28,
          EWS: 38,
          Sikh: 0,
          Christian: 0,
          CW: 19,
          PwBD: 0,
          KM: 0,
        },
      },
      {
        name: "Zakir Husain Delhi College (Evening)",
        seats: {
          UR: 93,
          OBC_NCL: 63,
          SC: 35,
          ST: 16,
          EWS: 24,
          Sikh: 0,
          Christian: 0,
          CW: 12,
          PwBD: 14,
          KM: 3,
        },
      },
    ],
  },
  {
    id: 29,
    name: "B.Sc. (Hons.) Anthropology",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific:
              "Biology / Biological Studies / Biotechnology / Biochemistry",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Hansraj College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 30,
    name: "B.Sc. (Hons.) Biological Science",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific:
              "Biology / Biological Studies / Biotechnology / Biochemistry",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
    ],
  },
  {
    id: 31,
    name: "B.Sc. (Hons.) Biomedical Science",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific:
              "Biology / Biological Studies / Biotechnology / Biochemistry",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Acharya Narendra Dev College",
        seats: {
          UR: 26,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Bhaskaracharya College of Applied Sciences",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 32,
    name: "B.Sc. (Hons.) Biochemistry",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific:
              "Biology / Biological Studies / Biotechnology / Biochemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific:
              "Biology / Biological Studies / Biotechnology / Biochemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 12,
          OBC_NCL: 8,
          SC: 4,
          ST: 2,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Deshbandhu College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Institute of Home Economics (W)",
        seats: {
          UR: 15,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 33,
    name: "B.Sc. (Hons.) Botany",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific:
              "Biology / Biological Studies / Biotechnology / Biochemistry",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Acharya Narendra Dev College",
        seats: {
          UR: 26,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Bhaskaracharya College of Applied Sciences",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Deen Dayal Upadhyaya College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Deshbandhu College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 11,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 1,
        },
      },
      {
        name: "Hansraj College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Kalindi College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 19,
          OBC_NCL: 14,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Maitreyi College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 15,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 20,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 20,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Swami Shardhanand College",
        seats: {
          UR: 18,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 2,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 17,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 34,
    name: "B.Sc. (Hons.) Microbiology",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific:
              "Biology / Biological Studies / Biotechnology / Biochemistry",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Bhaskaracharya College of Applied Sciences",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Institute of Home Economics (W)",
        seats: {
          UR: 15,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Ram Lal Anand College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Swami Shardhanand College",
        seats: {
          UR: 18,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 2,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 2,
          KM: 1,
        },
      },
    ],
  },
  {
    id: 35,
    name: "B.Sc. (Hons.) Zoology",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific:
              "Biology / Biological Studies / Biotechnology / Biochemistry",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Acharya Narendra Dev College",
        seats: {
          UR: 26,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Bhaskaracharya College of Applied Sciences",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Deen Dayal Upadhyaya College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Deshbandhu College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 11,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 1,
        },
      },
      {
        name: "Hansraj College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Kalindi College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 19,
          OBC_NCL: 14,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Maitreyi College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 15,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 20,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 20,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Swami Shardhanand College",
        seats: {
          UR: 18,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 2,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 19,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 36,
    name: "B.Sc. (Hons.) Chemistry",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Acharya Narendra Dev College",
        seats: {
          UR: 26,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Atma Ram Sanatan Dharma College",
        seats: {
          UR: 35,
          OBC_NCL: 23,
          SC: 13,
          ST: 6,
          EWS: 9,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Bhaskaracharya College of Applied Sciences",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 12,
          OBC_NCL: 8,
          SC: 4,
          ST: 2,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Deen Dayal Upadhyaya College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Deshbandhu College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Hansraj College",
        seats: {
          UR: 35,
          OBC_NCL: 23,
          SC: 13,
          ST: 7,
          EWS: 9,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 32,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Kalindi College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 58,
          OBC_NCL: 39,
          SC: 22,
          ST: 11,
          EWS: 14,
          Sikh: 0,
          Christian: 0,
          PwBD: 7,
          CW: 7,
          KM: 7,
        },
      },
      {
        name: "Maitreyi College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Motilal Nehru College",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Rajdhani College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 3,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 47,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Shyam Lal College",
        seats: {
          UR: 13,
          OBC_NCL: 9,
          SC: 5,
          ST: 2,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 10,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 10,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "St. Stephen's College",
        seats: {
          UR: 21,
          OBC_NCL: 0,
          SC: 3,
          ST: 1,
          EWS: 0,
          Sikh: 0,
          Christian: 25,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Swami Shardhanand College",
        seats: {
          UR: 18,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 35,
          OBC_NCL: 23,
          SC: 13,
          ST: 6,
          EWS: 9,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
    ],
  },
  {
    id: 37,
    name: "B.Sc. (Hons.) Physics",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Acharya Narendra Dev College",
        seats: {
          UR: 26,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Atma Ram Sanatan Dharma College",
        seats: {
          UR: 35,
          OBC_NCL: 23,
          SC: 13,
          ST: 6,
          EWS: 9,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Bhagini Nivedita College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Bhaskaracharya College of Applied Sciences",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Deen Dayal Upadhyaya College",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Deshbandhu College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Hansraj College",
        seats: {
          UR: 35,
          OBC_NCL: 23,
          SC: 13,
          ST: 7,
          EWS: 9,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 32,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Kalindi College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Keshav Mahavidyalaya",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 58,
          OBC_NCL: 39,
          SC: 22,
          ST: 11,
          EWS: 14,
          Sikh: 0,
          Christian: 0,
          PwBD: 7,
          CW: 7,
          KM: 7,
        },
      },
      {
        name: "Maitreyi College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 35,
          OBC_NCL: 23,
          SC: 13,
          ST: 6,
          EWS: 9,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Motilal Nehru College",
        seats: {
          UR: 31,
          OBC_NCL: 22,
          SC: 11,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 2,
        },
      },
      {
        name: "Rajdhani College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 47,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 20,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 20,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "St. Stephen's College",
        seats: {
          UR: 21,
          OBC_NCL: 0,
          SC: 3,
          ST: 1,
          EWS: 0,
          Sikh: 0,
          Christian: 25,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Swami Shardhanand College",
        seats: {
          UR: 18,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 2,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 2,
          KM: 1,
        },
      },
    ],
  },
  {
    id: 38,
    name: "B.Sc. (Hons.) Polymer Science",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Bhaskaracharya College of Applied Sciences",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
    ],
  },
  {
    id: 39,
    name: "B.Sc. (Hons.) Computer Science",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Acharya Narendra Dev College",
        seats: {
          UR: 26,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Aryabhatta College",
        seats: {
          UR: 21,
          OBC_NCL: 14,
          SC: 8,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Atma Ram Sanatan Dharma College",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Bhaskaracharya College of Applied Sciences",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "College of Vocational Studies",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Deen Dayal Upadhyaya College",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Hansraj College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Indraprastha College for Women (W)",
        seats: {
          UR: 26,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Kalindi College (W)",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Keshav Mahavidyalaya",
        seats: {
          UR: 46,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Mata Sundri College for Women (W)",
        seats: {
          UR: 23,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 23,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "P.G.D.A.V. College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Ram Lal Anand College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Ramanujan College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 2,
          KM: 3,
        },
      },
      {
        name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Shaheed Sukhdev College Business Studies",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shyama Prasad Mukherji College For Women (W)",
        seats: {
          UR: 28,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Sri Guru Gobind Singh College of Commerce",
        seats: {
          UR: 23,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 23,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 23,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 23,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 40,
    name: "B.Sc. (Hons.) Electronics",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Computer Science / Information Practices",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Acharya Narendra Dev College",
        seats: {
          UR: 26,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Atma Ram Sanatan Dharma College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Bhaskaracharya College of Applied Sciences",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Deen Dayal Upadhyaya College",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Hansraj College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Keshav Mahavidyalaya",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Maharaja Agrasen College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Rajdhani College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Aurobindo College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 10,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 10,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 41,
    name: "B.Sc. (Hons.) Environmental Science",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific:
              "Biology / Biological Studies / Biotechnology / Biochemistry",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Ramanujan College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 42,
    name: "B.Sc. (Hons.) Food Technology",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific:
              "Biology / Biological Studies / Biotechnology / Biochemistry",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Bhaskaracharya College of Applied Sciences",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Institute of Home Economics (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Lady Irwin College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 43,
    name: "B.Sc. (Hons.) Geology",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Geography / Geology",
          },
        ],
      },
      {
        name: "Combination III",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific:
              "Biology / Biological Studies / Biotechnology / Biochemistry",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Hansraj College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Ram Lal Anand College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 44,
    name: "B.Sc. (Hons.) Home Science",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific:
              "Biology / Biological Studies / Biotechnology / Biochemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific:
              "Biology / Biological Studies / Biotechnology / Biochemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Bhagini Nivedita College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Institute of Home Economics (W)",
        seats: {
          UR: 46,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Lady Irwin College (W)",
        seats: {
          UR: 51,
          OBC_NCL: 34,
          SC: 19,
          ST: 10,
          EWS: 13,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Lakshmibai College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Vivekananda College (W)",
        seats: {
          UR: 12,
          OBC_NCL: 8,
          SC: 5,
          ST: 2,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 45,
    name: "B.Sc. (Hons.) Instrumentation",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Computer Science / Information Practices",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Bhaskaracharya College of Applied Sciences",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 46,
    name: "B.Sc. (Hons.) Mathematics",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Acharya Narendra Dev College",
        seats: {
          UR: 26,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Aryabhatta College",
        seats: {
          UR: 21,
          OBC_NCL: 14,
          SC: 8,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Atma Ram Sanatan Dharma College",
        seats: {
          UR: 38,
          OBC_NCL: 26,
          SC: 14,
          ST: 7,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Bharati College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Deen Dayal Upadhyaya College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 3,
        },
      },
      {
        name: "Deshbandhu College",
        seats: {
          UR: 47,
          OBC_NCL: 32,
          SC: 18,
          ST: 9,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 47,
          OBC_NCL: 32,
          SC: 18,
          ST: 9,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 1,
        },
      },
      {
        name: "Hansraj College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Indraprastha College for Women (W)",
        seats: {
          UR: 26,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Janki Devi Memorial College (W)",
        seats: {
          UR: 51,
          OBC_NCL: 34,
          SC: 19,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Jesus & Mary College (W)",
        seats: {
          UR: 25,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 0,
          Christian: 25,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Kalindi College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Kamala Nehru College (W)",
        seats: {
          UR: 19,
          OBC_NCL: 14,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Keshav Mahavidyalaya",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 33,
          OBC_NCL: 23,
          SC: 13,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Lady Shri Ram College for Women (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Lakshmibai College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Maitreyi College (W)",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Mata Sundri College for Women (W)",
        seats: {
          UR: 30,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 30,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 35,
          OBC_NCL: 24,
          SC: 13,
          ST: 7,
          EWS: 9,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Motilal Nehru College",
        seats: {
          UR: 31,
          OBC_NCL: 22,
          SC: 11,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 2,
        },
      },
      {
        name: "P.G.D.A.V. College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "P.G.D.A.V. College (Evening)",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Rajdhani College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Ram Lal Anand College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Ramanujan College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 2,
          KM: 3,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Satyawati College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 0,
        },
      },
      {
        name: "Shaheed Bhagat Singh College",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 46,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Shyam Lal College",
        seats: {
          UR: 19,
          OBC_NCL: 12,
          SC: 7,
          ST: 3,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Shyama Prasad Mukherji College For Women (W)",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Sri Guru Nanak Dev Khalsa College",
        seats: {
          UR: 23,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 23,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 20,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 20,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 47,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 7,
          CW: 7,
          KM: 7,
        },
      },
      {
        name: "St. Stephen's College",
        seats: {
          UR: 21,
          OBC_NCL: 0,
          SC: 3,
          ST: 1,
          EWS: 0,
          Sikh: 0,
          Christian: 25,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Vivekananda College (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 39,
          OBC_NCL: 26,
          SC: 15,
          ST: 7,
          EWS: 9,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 4,
        },
      },
    ],
  },
  {
    id: 47,
    name: "B.Sc. (Hons.) Statistics",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Hindu College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 19,
          OBC_NCL: 14,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Lady Shri Ram College for Women (W)",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Mata Sundri College for Women (W)",
        seats: {
          UR: 23,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 23,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "P.G.D.A.V College",
        seats: {
          UR: 20,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Ram Lal Anand College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Ramanujan College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 2,
          KM: 3,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 48,
    name: "B.Tech. Information Technology and Mathematical Innovation",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Cluster Innovation Centre",
        seats: {
          UR: 20,
          OBC_NCL: 14,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 0,
        },
      },
    ],
  },
  {
    id: 49,
    name: "B.Sc. (Prog.) Applied Life Science",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific:
              "Biology / Biological Studies / Biotechnology / Biochemistry",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Swami Shardhanand College",
        seats: {
          UR: 18,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 2,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 2,
          KM: 1,
        },
      },
    ],
  },
  {
    id: 50,
    name: "B.Sc. (Prog.) Applied Physical Science with Industrial Chemistry",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Atma Ram Sanatan Dharma College",
        seats: {
          UR: 24,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Deshbandhu College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Rajdhani College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 51,
    name: "B.Sc. (Prog.) Applied Physical Science with Analytical Methods in Chemistry & Biochemistry",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Kirori Mal College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 52,
    name: "B.Sc. (Pass) Home Science",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination III",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Institute of Home Economics (W)",
        seats: {
          UR: 109,
          OBC_NCL: 73,
          SC: 41,
          ST: 20,
          EWS: 27,
          Sikh: 0,
          Christian: 0,
          PwBD: 14,
          CW: 14,
          KM: 14,
        },
      },
      {
        name: "Lady Irwin College (W)",
        seats: {
          UR: 111,
          OBC_NCL: 75,
          SC: 42,
          ST: 21,
          EWS: 28,
          Sikh: 0,
          Christian: 0,
          PwBD: 14,
          CW: 14,
          KM: 14,
        },
      },
    ],
  },
  {
    id: 53,
    name: "B.Sc. (Prog.) Life Science",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific:
              "Biology / Biological Studies / Biotechnology / Biochemistry",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Acharya Narendra Dev College",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Deen Dayal Upadhyaya College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Deshbandhu College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 46,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 2,
        },
      },
      {
        name: "Hansraj College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Kalindi College (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 1,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 17,
          OBC_NCL: 12,
          SC: 6,
          ST: 4,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Maitreyi College (W)",
        seats: {
          UR: 47,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 13,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 18,
          OBC_NCL: 12,
          SC: 7,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 58,
          OBC_NCL: 39,
          SC: 22,
          ST: 11,
          EWS: 14,
          Sikh: 0,
          Christian: 0,
          PwBD: 7,
          CW: 7,
          KM: 7,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 46,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Sri Aurobindo College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 1,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 20,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 20,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 62,
          OBC_NCL: 42,
          SC: 23,
          ST: 12,
          EWS: 15,
          Sikh: 0,
          Christian: 0,
          PwBD: 9,
          CW: 9,
          KM: 9,
        },
      },
      {
        name: "Swami Shardhanand College",
        seats: {
          UR: 53,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 6,
          KM: 1,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 35,
          OBC_NCL: 23,
          SC: 13,
          ST: 6,
          EWS: 9,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
    ],
  },
  {
    id: 54,
    name: "B.Sc. (Prog.) Mathematical Science",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Deen Dayal Upadhyaya College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Keshav Mahavidyalaya",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Maharaja Agrasen College",
        seats: {
          UR: 27,
          OBC_NCL: 19,
          SC: 10,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "P.G.D.A.V College",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
    ],
  },
  {
    id: 55,
    name: "B.Sc. In Physical Education, Health Education & Sports",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physical Education (Yoga, Sports)",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physical Education (Yoga, Sports)",
          },
          {
            count: 1,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination III",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination IV",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Indira Gandhi Institute of Physical Education and Sports Sciences",
        seats: {
          UR: 54,
          OBC_NCL: 36,
          SC: 20,
          ST: 10,
          EWS: 15,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 0,
          KM: 0,
        },
      },
    ],
  },
  {
    id: 56,
    name: "B.Sc. (Prog.) Physical Science with Chemistry",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Acharya Narendra Dev College",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Atma Ram Sanatan Dharma College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Bhagini Nivedita College (W)",
        seats: {
          UR: 18,
          OBC_NCL: 12,
          SC: 7,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Deen Dayal Upadhyaya College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Deshbandhu College",
        seats: {
          UR: 62,
          OBC_NCL: 42,
          SC: 23,
          ST: 12,
          EWS: 15,
          Sikh: 0,
          Christian: 0,
          PwBD: 8,
          CW: 8,
          KM: 8,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 62,
          OBC_NCL: 42,
          SC: 24,
          ST: 11,
          EWS: 15,
          Sikh: 0,
          Christian: 0,
          PwBD: 8,
          CW: 7,
          KM: 8,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 11,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 1,
        },
      },
      {
        name: "Hansraj College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 58,
          OBC_NCL: 39,
          SC: 22,
          ST: 11,
          EWS: 14,
          Sikh: 0,
          Christian: 0,
          PwBD: 7,
          CW: 7,
          KM: 7,
        },
      },
      {
        name: "Maharaja Agrasen College",
        seats: {
          UR: 8,
          OBC_NCL: 5,
          SC: 3,
          ST: 2,
          EWS: 2,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Maitreyi College (W)",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Motilal Nehru College",
        seats: {
          UR: 31,
          OBC_NCL: 22,
          SC: 11,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 2,
        },
      },
      {
        name: "Rajdhani College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 63,
          OBC_NCL: 42,
          SC: 23,
          ST: 12,
          EWS: 16,
          Sikh: 0,
          Christian: 0,
          PwBD: 7,
          CW: 7,
          KM: 7,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Shyam Lal College",
        seats: {
          UR: 61,
          OBC_NCL: 41,
          SC: 23,
          ST: 11,
          EWS: 15,
          Sikh: 0,
          Christian: 0,
          PwBD: 8,
          CW: 8,
          KM: 8,
        },
      },
      {
        name: "Sri Aurobindo College",
        seats: {
          UR: 46,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 2,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 20,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 20,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "St. Stephen's College",
        seats: {
          UR: 11,
          OBC_NCL: 0,
          SC: 1,
          ST: 0,
          EWS: 0,
          Sikh: 0,
          Christian: 12,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Swami Shardhanand College",
        seats: {
          UR: 53,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 6,
          KM: 1,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 35,
          OBC_NCL: 23,
          SC: 13,
          ST: 6,
          EWS: 9,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
    ],
  },
  {
    id: 57,
    name: "B.Sc. (Prog.) Physical Science with Electronics",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Computer Science / Information Practices",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Acharya Narendra Dev College",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Atma Ram Sanatan Dharma College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Rajdhani College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 30,
          OBC_NCL: 21,
          SC: 12,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Shyam Lal College",
        seats: {
          UR: 28,
          OBC_NCL: 19,
          SC: 10,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
    ],
  },
  {
    id: 58,
    name: "B.Sc. (Prog.) Physical Science with Computer Science/Informatics Practices",
    category: "Science, Math & Tech",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Chemistry",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Physics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Computer Science / Information Practices",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Acharya Narendra Dev College",
        seats: {
          UR: 23,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Atma Ram Sanatan Dharma College",
        seats: {
          UR: 31,
          OBC_NCL: 20,
          SC: 12,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Bhagini Nivedita College (W)",
        seats: {
          UR: 18,
          OBC_NCL: 12,
          SC: 7,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Deen Dayal Upadhyaya College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Deshbandhu College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Hansraj College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Kalindi College (W)",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 1,
        },
      },
      {
        name: "Keshav Mahavidyalaya",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 16,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Maharaja Agrasen College",
        seats: {
          UR: 19,
          OBC_NCL: 13,
          SC: 7,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Maitreyi College (W)",
        seats: {
          UR: 15,
          OBC_NCL: 11,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 18,
          OBC_NCL: 12,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Motilal Nehru College",
        seats: {
          UR: 16,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 1,
        },
      },
      {
        name: "Rajdhani College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 2,
          KM: 3,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Shyam Lal College",
        seats: {
          UR: 28,
          OBC_NCL: 19,
          SC: 10,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 10,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 10,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "St. Stephen's College",
        seats: {
          UR: 10,
          OBC_NCL: 0,
          SC: 2,
          ST: 1,
          EWS: 0,
          Sikh: 0,
          Christian: 13,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
    ],
  },
  {
    id: 59,
    name: "B.Com. (Hons.)",
    category: "Commerce & Management",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Accountancy / Book Keeping",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Acharya Narendra Dev College",
        seats: {
          UR: 50,
          OBC_NCL: 34,
          SC: 19,
          ST: 9,
          EWS: 13,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Aditi Mahavidyalaya (W)",
        seats: {
          UR: 27,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Aryabhatta College",
        seats: {
          UR: 21,
          OBC_NCL: 14,
          SC: 8,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Atma Ram Sanatan Dharma College",
        seats: {
          UR: 71,
          OBC_NCL: 47,
          SC: 26,
          ST: 13,
          EWS: 17,
          Sikh: 0,
          Christian: 0,
          PwBD: 9,
          CW: 9,
          KM: 9,
        },
      },
      {
        name: "Bharati College (W)",
        seats: {
          UR: 61,
          OBC_NCL: 41,
          SC: 23,
          ST: 11,
          EWS: 15,
          Sikh: 0,
          Christian: 0,
          PwBD: 8,
          CW: 8,
          KM: 8,
        },
      },
      {
        name: "College of Vocational Studies",
        seats: {
          UR: 39,
          OBC_NCL: 26,
          SC: 14,
          ST: 7,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 56,
          OBC_NCL: 38,
          SC: 21,
          ST: 10,
          EWS: 14,
          Sikh: 0,
          Christian: 0,
          PwBD: 7,
          CW: 7,
          KM: 7,
        },
      },
      {
        name: "Deen Dayal Upadhyaya College",
        seats: {
          UR: 62,
          OBC_NCL: 42,
          SC: 23,
          ST: 12,
          EWS: 15,
          Sikh: 0,
          Christian: 0,
          PwBD: 8,
          CW: 8,
          KM: 7,
        },
      },
      {
        name: "Delhi College of Arts and Commerce",
        seats: {
          UR: 46,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Deshbandhu College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Dr. Bhim Rao Ambedkar College",
        seats: {
          UR: 63,
          OBC_NCL: 42,
          SC: 23,
          ST: 12,
          EWS: 14,
          Sikh: 0,
          Christian: 0,
          PwBD: 8,
          CW: 8,
          KM: 8,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 93,
          OBC_NCL: 62,
          SC: 36,
          ST: 17,
          EWS: 23,
          Sikh: 0,
          Christian: 0,
          PwBD: 12,
          CW: 12,
          KM: 12,
        },
      },
      {
        name: "Dyal Singh College (Evening)",
        seats: {
          UR: 39,
          OBC_NCL: 26,
          SC: 14,
          ST: 7,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 63,
          OBC_NCL: 42,
          SC: 23,
          ST: 12,
          EWS: 16,
          Sikh: 0,
          Christian: 0,
          PwBD: 8,
          CW: 8,
          KM: 2,
        },
      },
      {
        name: "Hansraj College",
        seats: {
          UR: 105,
          OBC_NCL: 70,
          SC: 39,
          ST: 20,
          EWS: 26,
          Sikh: 0,
          Christian: 0,
          PwBD: 13,
          CW: 13,
          KM: 13,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 32,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Indraprastha College for Women (W)",
        seats: {
          UR: 57,
          OBC_NCL: 38,
          SC: 21,
          ST: 11,
          EWS: 15,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 8,
          KM: 8,
        },
      },
      {
        name: "Janki Devi Memorial College (W)",
        seats: {
          UR: 70,
          OBC_NCL: 46,
          SC: 26,
          ST: 13,
          EWS: 17,
          Sikh: 0,
          Christian: 0,
          PwBD: 9,
          CW: 9,
          KM: 9,
        },
      },
      {
        name: "Jesus & Mary College (W)",
        seats: {
          UR: 50,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 0,
          Christian: 50,
          PwBD: 5,
          CW: 5,
          KM: 4,
        },
      },
      {
        name: "Kalindi College (W)",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 1,
        },
      },
      {
        name: "Kamala Nehru College (W)",
        seats: {
          UR: 27,
          OBC_NCL: 19,
          SC: 10,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 0,
        },
      },
      {
        name: "Keshav Mahavidyalaya",
        seats: {
          UR: 77,
          OBC_NCL: 52,
          SC: 29,
          ST: 15,
          EWS: 19,
          Sikh: 0,
          Christian: 0,
          PwBD: 10,
          CW: 10,
          KM: 10,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 43,
          OBC_NCL: 29,
          SC: 16,
          ST: 8,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Lady Shri Ram College for Women (W)",
        seats: {
          UR: 27,
          OBC_NCL: 18,
          SC: 10,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Lakshmibai College (W)",
        seats: {
          UR: 46,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Maharaja Agrasen College",
        seats: {
          UR: 77,
          OBC_NCL: 52,
          SC: 29,
          ST: 15,
          EWS: 20,
          Sikh: 0,
          Christian: 0,
          PwBD: 10,
          CW: 10,
          KM: 10,
        },
      },
      {
        name: "Maitreyi College (W)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 11,
          ST: 6,
          EWS: 9,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Mata Sundri College for Women (W)",
        seats: {
          UR: 90,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 90,
          Christian: 0,
          PwBD: 9,
          CW: 9,
          KM: 9,
        },
      },
      {
        name: "Motilal Nehru College",
        seats: {
          UR: 78,
          OBC_NCL: 52,
          SC: 29,
          ST: 14,
          EWS: 20,
          Sikh: 0,
          Christian: 0,
          PwBD: 10,
          CW: 10,
          KM: 6,
        },
      },
      {
        name: "Motilal Nehru College (Evening)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "P.G.D.A.V. College",
        seats: {
          UR: 94,
          OBC_NCL: 62,
          SC: 35,
          ST: 17,
          EWS: 23,
          Sikh: 0,
          Christian: 0,
          PwBD: 12,
          CW: 12,
          KM: 12,
        },
      },
      {
        name: "P.G.D.A.V. College (Evening)",
        seats: {
          UR: 39,
          OBC_NCL: 26,
          SC: 15,
          ST: 7,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Rajdhani College",
        seats: {
          UR: 62,
          OBC_NCL: 42,
          SC: 23,
          ST: 12,
          EWS: 15,
          Sikh: 0,
          Christian: 0,
          PwBD: 7,
          CW: 7,
          KM: 7,
        },
      },
      {
        name: "Ram Lal Anand College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Ramanujan College",
        seats: {
          UR: 76,
          OBC_NCL: 51,
          SC: 28,
          ST: 14,
          EWS: 19,
          Sikh: 0,
          Christian: 0,
          PwBD: 9,
          CW: 9,
          KM: 9,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 50,
          OBC_NCL: 34,
          SC: 19,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Satyawati College",
        seats: {
          UR: 78,
          OBC_NCL: 52,
          SC: 29,
          ST: 14,
          EWS: 20,
          Sikh: 0,
          Christian: 0,
          PwBD: 10,
          CW: 10,
          KM: 0,
        },
      },
      {
        name: "Satyawati College (Evening)",
        seats: {
          UR: 63,
          OBC_NCL: 41,
          SC: 23,
          ST: 13,
          EWS: 15,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 0,
          KM: 0,
        },
      },
      {
        name: "Shaheed Bhagat Singh College",
        seats: {
          UR: 194,
          OBC_NCL: 129,
          SC: 71,
          ST: 35,
          EWS: 51,
          Sikh: 0,
          Christian: 0,
          PwBD: 24,
          CW: 24,
          KM: 24,
        },
      },
      {
        name: "Shaheed Bhagat Singh College (Evening)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 46,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Shri Ram College of Commerce",
        seats: {
          UR: 253,
          OBC_NCL: 169,
          SC: 94,
          ST: 47,
          EWS: 63,
          Sikh: 0,
          Christian: 0,
          PwBD: 31,
          CW: 31,
          KM: 31,
        },
      },
      {
        name: "Shyam Lal College",
        seats: {
          UR: 93,
          OBC_NCL: 62,
          SC: 35,
          ST: 17,
          EWS: 24,
          Sikh: 0,
          Christian: 0,
          PwBD: 12,
          CW: 12,
          KM: 12,
        },
      },
      {
        name: "Shyam Lal College (Evening)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Shyama Prasad Mukherji College For Women (W)",
        seats: {
          UR: 47,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Sri Aurobindo College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 5,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 2,
        },
      },
      {
        name: "Sri Aurobindo College (Evening)",
        seats: {
          UR: 39,
          OBC_NCL: 26,
          SC: 14,
          ST: 7,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 14,
          KM: 0,
        },
      },
      {
        name: "Sri Guru Gobind Singh College of Commerce",
        seats: {
          UR: 100,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 100,
          Christian: 0,
          PwBD: 10,
          CW: 10,
          KM: 10,
        },
      },
      {
        name: "Sri Guru Nanak Dev Khalsa College",
        seats: {
          UR: 40,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 40,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 60,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 60,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 47,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 7,
          CW: 7,
          KM: 7,
        },
      },
      {
        name: "Swami Shardhanand College",
        seats: {
          UR: 53,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 6,
          KM: 1,
        },
      },
      {
        name: "Vivekananda College (W)",
        seats: {
          UR: 40,
          OBC_NCL: 26,
          SC: 15,
          ST: 7,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 85,
          OBC_NCL: 57,
          SC: 32,
          ST: 16,
          EWS: 21,
          Sikh: 0,
          Christian: 0,
          PwBD: 11,
          CW: 11,
          KM: 9,
        },
      },
      {
        name: "Zakir Husain Delhi College (Evening)",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 3,
        },
      },
    ],
  },
  {
    id: 60,
    name: "B.Com.",
    category: "Commerce & Management",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Aditi Mahavidyalaya (W)",
        seats: {
          UR: 22,
          OBC_NCL: 15,
          SC: 8,
          ST: 4,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Aryabhatta College",
        seats: {
          UR: 21,
          OBC_NCL: 14,
          SC: 8,
          ST: 4,
          EWS: 5,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Atma Ram Sanatan Dharma College",
        seats: {
          UR: 77,
          OBC_NCL: 52,
          SC: 29,
          ST: 14,
          EWS: 21,
          Sikh: 0,
          Christian: 0,
          PwBD: 10,
          CW: 10,
          KM: 10,
        },
      },
      {
        name: "Bhagini Nivedita College (W)",
        seats: {
          UR: 46,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 3,
        },
      },
      {
        name: "Bharati College (W)",
        seats: {
          UR: 78,
          OBC_NCL: 52,
          SC: 29,
          ST: 14,
          EWS: 19,
          Sikh: 0,
          Christian: 0,
          PwBD: 10,
          CW: 10,
          KM: 10,
        },
      },
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 39,
          OBC_NCL: 26,
          SC: 14,
          ST: 7,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Delhi College of Arts and Commerce",
        seats: {
          UR: 69,
          OBC_NCL: 46,
          SC: 26,
          ST: 13,
          EWS: 17,
          Sikh: 0,
          Christian: 0,
          PwBD: 8,
          CW: 8,
          KM: 8,
        },
      },
      {
        name: "Dr. Bhim Rao Ambedkar College",
        seats: {
          UR: 93,
          OBC_NCL: 62,
          SC: 35,
          ST: 18,
          EWS: 23,
          Sikh: 0,
          Christian: 0,
          PwBD: 12,
          CW: 12,
          KM: 12,
        },
      },
      {
        name: "Dyal Singh College",
        seats: {
          UR: 93,
          OBC_NCL: 62,
          SC: 36,
          ST: 17,
          EWS: 23,
          Sikh: 0,
          Christian: 0,
          PwBD: 12,
          CW: 11,
          KM: 12,
        },
      },
      {
        name: "Dyal Singh College (Evening)",
        seats: {
          UR: 77,
          OBC_NCL: 52,
          SC: 29,
          ST: 15,
          EWS: 20,
          Sikh: 0,
          Christian: 0,
          PwBD: 10,
          CW: 10,
          KM: 10,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 93,
          OBC_NCL: 62,
          SC: 35,
          ST: 17,
          EWS: 23,
          Sikh: 0,
          Christian: 0,
          PwBD: 11,
          CW: 11,
          KM: 4,
        },
      },
      {
        name: "Janki Devi Memorial College (W)",
        seats: {
          UR: 47,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Jesus & Mary College (W)",
        seats: {
          UR: 25,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 0,
          Christian: 25,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Kalindi College (W)",
        seats: {
          UR: 46,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 1,
        },
      },
      {
        name: "Kamala Nehru College (W)",
        seats: {
          UR: 62,
          OBC_NCL: 42,
          SC: 23,
          ST: 12,
          EWS: 16,
          Sikh: 0,
          Christian: 0,
          PwBD: 8,
          CW: 8,
          KM: 1,
        },
      },
      {
        name: "Kirori Mal College",
        seats: {
          UR: 43,
          OBC_NCL: 29,
          SC: 16,
          ST: 8,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Lakshmibai College (W)",
        seats: {
          UR: 94,
          OBC_NCL: 62,
          SC: 35,
          ST: 17,
          EWS: 23,
          Sikh: 0,
          Christian: 0,
          PwBD: 12,
          CW: 12,
          KM: 12,
        },
      },
      {
        name: "Maitreyi College (W)",
        seats: {
          UR: 47,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Mata Sundri College for Women (W)",
        seats: {
          UR: 60,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 60,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Motilal Nehru College",
        seats: {
          UR: 93,
          OBC_NCL: 63,
          SC: 35,
          ST: 17,
          EWS: 23,
          Sikh: 0,
          Christian: 0,
          PwBD: 11,
          CW: 12,
          KM: 8,
        },
      },
      {
        name: "Motilal Nehru College (Evening)",
        seats: {
          UR: 46,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "P.G.D.A.V. College",
        seats: {
          UR: 140,
          OBC_NCL: 94,
          SC: 52,
          ST: 26,
          EWS: 34,
          Sikh: 0,
          Christian: 0,
          PwBD: 17,
          CW: 17,
          KM: 17,
        },
      },
      {
        name: "P.G.D.A.V. College (Evening)",
        seats: {
          UR: 94,
          OBC_NCL: 62,
          SC: 35,
          ST: 17,
          EWS: 23,
          Sikh: 0,
          Christian: 0,
          PwBD: 11,
          CW: 11,
          KM: 11,
        },
      },
      {
        name: "Ram Lal Anand College",
        seats: {
          UR: 39,
          OBC_NCL: 26,
          SC: 15,
          ST: 7,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Ramanujan College",
        seats: {
          UR: 50,
          OBC_NCL: 34,
          SC: 19,
          ST: 9,
          EWS: 13,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 37,
          OBC_NCL: 25,
          SC: 14,
          ST: 7,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "Satyawati College",
        seats: {
          UR: 78,
          OBC_NCL: 52,
          SC: 29,
          ST: 14,
          EWS: 20,
          Sikh: 0,
          Christian: 0,
          PwBD: 10,
          CW: 10,
          KM: 0,
        },
      },
      {
        name: "Satyawati College (Evening)",
        seats: {
          UR: 96,
          OBC_NCL: 63,
          SC: 35,
          ST: 18,
          EWS: 23,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 0,
          KM: 0,
        },
      },
      {
        name: "Shaheed Bhagat Singh College",
        seats: {
          UR: 78,
          OBC_NCL: 51,
          SC: 28,
          ST: 14,
          EWS: 21,
          Sikh: 0,
          Christian: 0,
          PwBD: 10,
          CW: 10,
          KM: 10,
        },
      },
      {
        name: "Shaheed Bhagat Singh College (Evening)",
        seats: {
          UR: 187,
          OBC_NCL: 125,
          SC: 69,
          ST: 35,
          EWS: 46,
          Sikh: 0,
          Christian: 0,
          PwBD: 23,
          CW: 23,
          KM: 23,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 46,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 12,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
      {
        name: "Shyam Lal College",
        seats: {
          UR: 103,
          OBC_NCL: 68,
          SC: 38,
          ST: 19,
          EWS: 25,
          Sikh: 0,
          Christian: 0,
          PwBD: 13,
          CW: 13,
          KM: 13,
        },
      },
      {
        name: "Shyam Lal College (Evening)",
        seats: {
          UR: 94,
          OBC_NCL: 62,
          SC: 35,
          ST: 17,
          EWS: 23,
          Sikh: 0,
          Christian: 0,
          PwBD: 12,
          CW: 12,
          KM: 12,
        },
      },
      {
        name: "Shyama Prasad Mukherji College For Women (W)",
        seats: {
          UR: 61,
          OBC_NCL: 40,
          SC: 22,
          ST: 11,
          EWS: 15,
          Sikh: 0,
          Christian: 0,
          PwBD: 7,
          CW: 7,
          KM: 7,
        },
      },
      {
        name: "Sri Aurobindo College",
        seats: {
          UR: 140,
          OBC_NCL: 94,
          SC: 52,
          ST: 26,
          EWS: 35,
          Sikh: 0,
          Christian: 0,
          PwBD: 17,
          CW: 17,
          KM: 7,
        },
      },
      {
        name: "Sri Aurobindo College (Evening)",
        seats: {
          UR: 117,
          OBC_NCL: 78,
          SC: 43,
          ST: 22,
          EWS: 29,
          Sikh: 0,
          Christian: 0,
          PwBD: 11,
          CW: 4,
          KM: 0,
        },
      },
      {
        name: "Sri Guru Gobind Singh College of Commerce",
        seats: {
          UR: 70,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 70,
          Christian: 0,
          PwBD: 7,
          CW: 7,
          KM: 7,
        },
      },
      {
        name: "Sri Guru Nanak Dev Khalsa College",
        seats: {
          UR: 90,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 90,
          Christian: 0,
          PwBD: 9,
          CW: 9,
          KM: 9,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 30,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 30,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Sri Venkateswara College",
        seats: {
          UR: 47,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 7,
          CW: 7,
          KM: 7,
        },
      },
      {
        name: "Swami Shardhanand College",
        seats: {
          UR: 214,
          OBC_NCL: 125,
          SC: 69,
          ST: 34,
          EWS: 21,
          Sikh: 0,
          Christian: 0,
          PwBD: 18,
          CW: 23,
          KM: 5,
        },
      },
      {
        name: "Vivekananda College (W)",
        seats: {
          UR: 58,
          OBC_NCL: 39,
          SC: 22,
          ST: 11,
          EWS: 14,
          Sikh: 0,
          Christian: 0,
          PwBD: 7,
          CW: 7,
          KM: 7,
        },
      },
      {
        name: "Zakir Husain Delhi College",
        seats: {
          UR: 47,
          OBC_NCL: 31,
          SC: 17,
          ST: 9,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 5,
        },
      },
      {
        name: "Zakir Husain Delhi College (Evening)",
        seats: {
          UR: 62,
          OBC_NCL: 41,
          SC: 23,
          ST: 11,
          EWS: 16,
          Sikh: 0,
          Christian: 0,
          PwBD: 8,
          CW: 8,
          KM: 7,
        },
      },
    ],
  },
  {
    id: 61,
    name: "Bachelor of Business Administration (Financial Investment Analysis)",
    category: "Commerce & Management",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "Domain",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Shaheed Sukhdev College Business Studies",
        seats: {
          UR: 46,
          OBC_NCL: 31,
          SC: 17,
          ST: 8,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
    ],
  },
  {
    id: 62,
    name: "B.A. (Hons.) Business Economics",
    category: "Commerce & Management",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "Domain",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Aryabhatta College",
        seats: {
          UR: 42,
          OBC_NCL: 28,
          SC: 16,
          ST: 8,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "College of Vocational Studies",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Dr. Bhim Rao Ambedkar College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 11,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 0,
          KM: 1,
        },
      },
      {
        name: "Lakshmibai College (W)",
        seats: {
          UR: 15,
          OBC_NCL: 10,
          SC: 6,
          ST: 3,
          EWS: 4,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Maharaja Agrasen College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shivaji College",
        seats: {
          UR: 31,
          OBC_NCL: 21,
          SC: 12,
          ST: 6,
          EWS: 8,
          Sikh: 0,
          Christian: 0,
          PwBD: 4,
          CW: 4,
          KM: 4,
        },
      },
      {
        name: "Sri Guru Gobind Singh College of Commerce",
        seats: {
          UR: 20,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 20,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Guru Nanak Dev Khalsa College",
        seats: {
          UR: 20,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 20,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
      {
        name: "Sri Guru Tegh Bahadur Khalsa College",
        seats: {
          UR: 20,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 20,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 63,
    name: "Bachelor of Management Studies",
    category: "Commerce & Management",
    combinations: [
      {
        name: "Required Combination",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "Domain",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Aryabhatta College",
        seats: {
          UR: 42,
          OBC_NCL: 28,
          SC: 16,
          ST: 8,
          EWS: 10,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
      {
        name: "College of Vocational Studies",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Deen Dayal Upadhyaya College",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Keshav Mahavidyalaya",
        seats: {
          UR: 24,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 0,
        },
      },
      {
        name: "Ram Lal Anand College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Ramanujan College",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 2,
          KM: 3,
        },
      },
      {
        name: "Shaheed Rajguru College of Applied Sciences for Women (W)",
        seats: {
          UR: 23,
          OBC_NCL: 16,
          SC: 9,
          ST: 4,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
      {
        name: "Shaheed Sukhdev College Business Studies",
        seats: {
          UR: 93,
          OBC_NCL: 63,
          SC: 35,
          ST: 17,
          EWS: 23,
          Sikh: 0,
          Christian: 0,
          PwBD: 12,
          CW: 12,
          KM: 12,
        },
      },
      {
        name: "Sri Guru Gobind Singh College of Commerce",
        seats: {
          UR: 23,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 23,
          Christian: 0,
          PwBD: 2,
          CW: 2,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 64,
    name: "B.A. (Hons.) Hindustani Music: Vocal/Instrumental",
    category: "Music & Fine Arts",
    combinations: [
      {
        name: "Required Combination (+ Performance Test)",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Performing Arts (Dance, Drama, Music)",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Alternative Combination I (+ Performance Test)",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Performing Arts (Dance, Drama, Music)",
          },
          {
            count: 1,
            type: "Domain",
          },
        ],
      },
      {
        name: "Alternative Combination II (+ Performance Test)",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Alternative Combination III (+ Performance Test)",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 8,
          OBC_NCL: 5,
          SC: 3,
          ST: 1,
          EWS: 2,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 5,
          OBC_NCL: 3,
          SC: 2,
          ST: 0,
          EWS: 1,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 0,
          KM: 0,
        },
      },
      {
        name: "Indraprastha College for Women (W)",
        seats: {
          UR: 15,
          OBC_NCL: 8,
          SC: 4,
          ST: 2,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 2,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 5,
          OBC_NCL: 3,
          SC: 2,
          ST: 0,
          EWS: 1,
          Sikh: 0,
          Christian: 0,
          PwBD: 1,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 10,
          OBC_NCL: 6,
          SC: 4,
          ST: 2,
          EWS: 3,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 0,
          KM: 0,
        },
      },
    ],
  },
  {
    id: 65,
    name: "B.A. (Hons.) Hindustani Music: Percussion",
    category: "Music & Fine Arts",
    combinations: [
      {
        name: "Required Combination (+ Performance Test)",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Performing Arts (Dance, Drama, Music)",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Alternative Combination I (+ Performance Test)",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Performing Arts (Dance, Drama, Music)",
          },
          {
            count: 1,
            type: "Domain",
          },
        ],
      },
      {
        name: "Alternative Combination II (+ Performance Test)",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Alternative Combination III (+ Performance Test)",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 2,
          OBC_NCL: 2,
          SC: 1,
          ST: 1,
          EWS: 1,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 0,
          KM: 0,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 2,
          OBC_NCL: 1,
          SC: 1,
          ST: 0,
          EWS: 1,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 0,
          KM: 0,
        },
      },
      {
        name: "Indraprastha College for Women (W)",
        seats: {
          UR: 2,
          OBC_NCL: 3,
          SC: 2,
          ST: 1,
          EWS: 1,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 2,
          OBC_NCL: 1,
          SC: 1,
          ST: 0,
          EWS: 1,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 0,
          KM: 0,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 4,
          OBC_NCL: 3,
          SC: 1,
          ST: 1,
          EWS: 1,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 0,
          KM: 0,
        },
      },
    ],
  },
  {
    id: 66,
    name: "B.A. (Hons.) Karnataka Music: Vocal/Instrumental",
    category: "Music & Fine Arts",
    combinations: [
      {
        name: "Required Combination (+ Performance Test)",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Performing Arts (Dance, Drama, Music)",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Alternative Combination I (+ Performance Test)",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Performing Arts (Dance, Drama, Music)",
          },
          {
            count: 1,
            type: "Domain",
          },
        ],
      },
      {
        name: "Alternative Combination II (+ Performance Test)",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Alternative Combination III (+ Performance Test)",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Daulat Ram College (W)",
        seats: {
          UR: 2,
          OBC_NCL: 1,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 0,
          KM: 0,
        },
      },
      {
        name: "Hindu College",
        seats: {
          UR: 1,
          OBC_NCL: 1,
          SC: 0,
          ST: 1,
          EWS: 0,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 0,
          KM: 0,
        },
      },
      {
        name: "Indraprastha College for Women (W)",
        seats: {
          UR: 2,
          OBC_NCL: 2,
          SC: 1,
          ST: 0,
          EWS: 1,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 1,
          OBC_NCL: 1,
          SC: 0,
          ST: 1,
          EWS: 0,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 0,
          KM: 0,
        },
      },
      {
        name: "Ramjas College",
        seats: {
          UR: 2,
          OBC_NCL: 1,
          SC: 1,
          ST: 0,
          EWS: 0,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 0,
          KM: 0,
        },
      },
    ],
  },
  {
    id: 67,
    name: "Bachelor of Fine Arts",
    category: "Fine Arts",
    combinations: [
      {
        name: "Required Combination (+ Practical Test)",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "College of Art",
        seats: {
          UR: 83,
          OBC_NCL: 56,
          SC: 31,
          ST: 15,
          EWS: 21,
          Sikh: 0,
          Christian: 0,
          PwBD: 0,
          CW: 0,
          KM: 0,
        },
      },
    ],
  },
  {
    id: 68,
    name: "B.Voc. Banking Operations",
    category: "Vocational",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination III",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Ramanujan College",
        seats: {
          UR: 25,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
    ],
  },
  {
    id: 69,
    name: "B.Voc. Health Care Management",
    category: "Vocational",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination III",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Jesus & Mary College (W)",
        seats: {
          UR: 25,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 0,
          Christian: 25,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 70,
    name: "B.Voc. Retail Management and IT",
    category: "Vocational",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination III",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Jesus & Mary College (W)",
        seats: {
          UR: 25,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 0,
          Christian: 25,
          PwBD: 3,
          CW: 3,
          KM: 2,
        },
      },
    ],
  },
  {
    id: 71,
    name: "B.Voc. Software Development",
    category: "Vocational",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination III",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
            specific: "Mathematics / Applied Mathematics",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Ramanujan College",
        seats: {
          UR: 25,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
    ],
  },
  {
    id: 72,
    name: "B.A. (Vocational Studies) Human Resource Management",
    category: "Vocational",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination III",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "College of Vocational Studies",
        seats: {
          UR: 51,
          OBC_NCL: 34,
          SC: 19,
          ST: 9,
          EWS: 13,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
    ],
  },
  {
    id: 73,
    name: "B.A. (Vocational Studies) Management and Marketing of Insurance",
    category: "Vocational",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination III",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "College of Vocational Studies",
        seats: {
          UR: 25,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
    ],
  },
  {
    id: 74,
    name: "B.A. (Vocational Studies) Marketing Management and Retail Business",
    category: "Vocational",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination III",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "College of Vocational Studies",
        seats: {
          UR: 51,
          OBC_NCL: 34,
          SC: 19,
          ST: 9,
          EWS: 13,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
    ],
  },
  {
    id: 75,
    name: "B.A. (Vocational Studies) Material Management",
    category: "Vocational",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination III",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "College of Vocational Studies",
        seats: {
          UR: 25,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
    ],
  },
  {
    id: 76,
    name: "B.A. (Vocational Studies) Office Management and Secretarial Practice",
    category: "Vocational",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination III",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "College of Vocational Studies",
        seats: {
          UR: 45,
          OBC_NCL: 30,
          SC: 17,
          ST: 8,
          EWS: 11,
          Sikh: 0,
          Christian: 0,
          PwBD: 5,
          CW: 5,
          KM: 5,
        },
      },
    ],
  },
  {
    id: 77,
    name: "B.A. (Vocational Studies) Small and Medium Enterprises",
    category: "Vocational",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination III",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "College of Vocational Studies",
        seats: {
          UR: 25,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
    ],
  },
  {
    id: 78,
    name: "B.A. (Vocational Studies) Tourism Management",
    category: "Vocational",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination III",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 1,
            type: "Domain",
          },
          {
            count: 1,
            type: "General Test",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "College of Vocational Studies",
        seats: {
          UR: 51,
          OBC_NCL: 34,
          SC: 19,
          ST: 9,
          EWS: 13,
          Sikh: 0,
          Christian: 0,
          PwBD: 6,
          CW: 6,
          KM: 6,
        },
      },
    ],
  },
  {
    id: 79,
    name: "Bachelor of Elementary Education",
    category: "Education",
    combinations: [
      {
        name: "Combination I",
        requirements: [
          {
            count: 1,
            type: "Language",
          },
          {
            count: 3,
            type: "Domain",
          },
        ],
      },
      {
        name: "Combination II",
        requirements: [
          {
            count: 2,
            type: "Language",
          },
          {
            count: 2,
            type: "Domain",
          },
        ],
      },
    ],
    colleges: [
      {
        name: "Aditi Mahavidyalaya (W)",
        seats: {
          UR: 25,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Gargi College (W)",
        seats: {
          UR: 25,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 1,
          KM: 1,
        },
      },
      {
        name: "Institute of Home Economics (W)",
        seats: {
          UR: 26,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 6,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 0,
        },
      },
      {
        name: "Jesus & Mary College (W)",
        seats: {
          UR: 25,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 0,
          Christian: 25,
          PwBD: 3,
          CW: 3,
          KM: 0,
        },
      },
      {
        name: "Lady Shri Ram College for Women (W)",
        seats: {
          UR: 25,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Mata Sundri College for Women (W)",
        seats: {
          UR: 27,
          OBC_NCL: 0,
          SC: 0,
          ST: 0,
          EWS: 0,
          Sikh: 27,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Miranda House (W)",
        seats: {
          UR: 25,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
      {
        name: "Shyama Prasad Mukherji College For Women (W)",
        seats: {
          UR: 25,
          OBC_NCL: 17,
          SC: 9,
          ST: 5,
          EWS: 7,
          Sikh: 0,
          Christian: 0,
          PwBD: 3,
          CW: 3,
          KM: 3,
        },
      },
    ],
  },
];
